export const diaryReportsKeys = {
  all: ["diaryReports"] as const,
  models: () => [...diaryReportsKeys.all, "models"] as const,
  project: (projectId: string) => [...diaryReportsKeys.all, "project", projectId] as const,
  list: (projectId: string, projectDiaryEntryId?: string) =>
    [...diaryReportsKeys.project(projectId), "list", projectDiaryEntryId ?? "all"] as const,
};
